// Service for Attendance List
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildRequiredQueryString } from '@/api/shared';
import type {
  LC_GetEmployeeAttendanceIn,
  LC_GetEmployeeAttendanceOut,
  AttendancePage,
} from '../types';
import { mapPage } from '../mappers';


export class AttendanceListService {
  async getEmployeeAttendance(
    employeeId: number,
    input: LC_GetEmployeeAttendanceIn,
  ): Promise<ApiResponse<AttendancePage>> {
    const queryString = buildRequiredQueryString({ ...input }, ['startDate']);
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.GET_EMPLOYEE_ATTENDANCE(employeeId)}${queryString}`;

    const response =
      await apiClient.get<LC_GetEmployeeAttendanceOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: false,
        data: null,
        error: response.error,
        status: response.status,
      };
    }
    return { success: true, data: mapPage(response.data), status: response.status };
  }
}

export const attendanceListService = new AttendanceListService();
